

export const isAuthenticatedGuard = (to, from, next) => {

    console.log('to========>', to)
    if (to.path == '/auto_post_tip' && localStorage.getItem('user_id') != 0)
        next({name: 'Page404'});
    if (to.path == '/betfair' && localStorage.getItem('user_id') != 0)
        next({name: 'Page404'});
    if (to.path == '/subscription_logo' && localStorage.getItem('user_id') != 0)
        next({name: 'Page404'});

    var membership_level = localStorage.getItem('membership_level')
    if (membership_level == 2 || membership_level == 1002 || membership_level == 3002 || membership_level == 5002) {
        if (to.name == 'UserTipStat' || to.name == 'UserStrategyStat' || to.name == 'UserStrategyStats' || to.name == 'UserStrategyFinancial') {
            if (from.path.includes('/pages/')) {
                next({                    
                    path: 'membership',
                    params: { nextUrl: to.fullPath }
                })
                return;
            }
            else {
                next({                    
                    path: 'pages/membership',
                    params: { nextUrl: to.fullPath }
                })
                return;
            }
        }
    }

   
        const token = localStorage.getItem('token');
        if(token) {
            if (localStorage.getItem('user_id') == 0) {        
                next();
                return;
            }
            
            var nexturl_name = to.name;

            if (nexturl_name == 'UserTipStat' || nexturl_name == 'UserSetting' || nexturl_name == 'home' || from.name == "MoneyManage") {
              
              next();
              return;
            }

            var membership_level = localStorage.getItem('membership_level')

            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function(){
                if (xhr.readyState === 4){
                    var response = JSON.parse(xhr.responseText);                    
                    
                    console.log(' =====   response ==== ',response)
                    var visit_allowed = false
                    if (response.membership_setting == undefined)
                        visit_allowed = true;
                    else
                        response.membership_setting.forEach((item) =>{
                          if (item.name == membership_level){

                             visit_allowed = item.value
                            
                          }
                        })
                    // if(response['setting'] == true) {
                    if( visit_allowed ) {
                      console.log('setting is true')

                      next();
                      return;
                    }
                    else {
                      console.log('setting is false')
                      if (from.path.includes('/pages/')) {
                        next({

                            // path: '/pages/404',
                            
                            path: 'membership',
                            params: { nextUrl: to.fullPath }
                        })
                      }
                      else {
                        next({

                            // path: '/pages/404',
                            
                            path: 'pages/membership',
                            params: { nextUrl: to.fullPath }
                        })
                      }
                      

                    }
                }
            };

            var data = {realname: nexturl_name}
            nexturl_name = nexturl_name.replace("/", " ");

            xhr.open('GET', `${process.env.VUE_APP_URL}api/pagesetting/check_page/${nexturl_name}`, true);
            xhr.send();
        }
        else
            next({name: 'Login'});
      
    
};